import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Auth from '../components/auth/Auth';
import App from '../App';
import WithRecaptcha from '../components/common/WithRecaptcha';
import { Loader } from '../components/common/Loader';
import { useAuthState } from '../+state/useAuthState';
import { useAuthRefresh } from '../queryHooks/auth/useAuthRefresh';

const Router = () => {
  const { initialized } = useAuthState();
  useAuthRefresh();

  return (
    <>
      {
        initialized
          ? <Routes>
            <Route path={'auth/*'} element={<WithRecaptcha><Auth/></WithRecaptcha>}/>
            <Route path={'*'} element={<App/>}/>
          </Routes>
          : <Loader/>
      }
    </>

  );
};

export default Router;